export default "__VITE_ASSET__CNk$uGW1__"